import { theme } from "antd"

export const UploadCloudIcon = () => {
  const { token } = theme.useToken()
  return (
    <svg
      fill="none"
      height="37"
      viewBox="0 0 36 37"
      width="36"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35.4934 15.4197L35.484 15.3822L30.2247 2.01816C29.9903 1.26348 29.2919 0.743164 28.4997 0.743164H7.18092C6.38404 0.743164 5.67623 1.27285 5.45123 2.03691L0.534043 15.265L0.519981 15.2979L0.510605 15.3354C0.449668 15.565 0.430918 15.7994 0.46373 16.0291C0.459043 16.1041 0.454355 16.1791 0.454355 16.2541V33.4057C0.455595 34.1611 0.75626 34.8853 1.29047 35.4195C1.82468 35.9538 2.54887 36.2544 3.30436 36.2557H32.7044C34.2747 36.2557 35.5544 34.976 35.559 33.4057V16.2541C35.559 16.1932 35.559 16.1322 35.5544 16.0807C35.5731 15.851 35.5544 15.6307 35.4934 15.4197ZM21.6278 13.4041L21.6137 14.14C21.5762 16.2447 20.1231 17.6604 17.9997 17.6604C16.9637 17.6604 16.0731 17.3275 15.4309 16.6947C14.7887 16.0619 14.4372 15.1807 14.4184 14.14L14.4044 13.4041H4.75748L8.48404 4.34316H27.1965L31.0262 13.4041H21.6278ZM4.04967 17.0041H11.4231C12.5622 19.6807 14.9856 21.2604 18.0044 21.2604C19.584 21.2604 21.0512 20.8197 22.2372 19.9853C23.2778 19.2541 24.0887 18.2322 24.6137 17.0041H31.9497V32.6557H4.04967V17.0041Z"
        fill={token.colorPrimary}
      />
    </svg>
  )
}
